// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"SimpleMsgDiv__outerBox__4DmWo"};